import _extends from "@babel/runtime-corejs3/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime-corejs3/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import _Set from "@babel/runtime-corejs3/core-js-stable/set";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import styled from 'styled-components';
import { fromEvent } from 'rxjs';
import * as op from 'rxjs/operators';
import { mergeCellProps, collectNodes, makeRecursiveMapper, isGroupColumn } from '../../utils';
import { internals } from '../../internals';
import { Classes } from '../../base/styles';
import { swapRTLDirection } from '../../base/utils';
import { getEventCoordinates } from './utils/touchEventUtils';
var TableHeaderCellResize = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  ", ": -5px;\n  height: 100%;\n  width: 10px;\n  cursor: ew-resize;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index:1;\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    display: block;\n    ", ": calc(50% - 1px);\n    width: 1px;\n    height: calc(100% - 14px);\n    top: 7px;\n  }\n"])), function (props) {
  return swapRTLDirection(props.direction, 'right');
}, function (props) {
  return swapRTLDirection(props.direction, 'left');
});
var TableHeaderGroupCellResize = styled(function (props) {
  return /*#__PURE__*/React.createElement(TableHeaderCellResize, _extends({}, props));
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  &:after {\n    height: 100%;\n    top: 0;\n  }\n"])));
function clamp(min, x, max) {
  return Math.max(min, Math.min(max, x));
}
function disableSelect(event) {
  event.preventDefault();
}
var stateKey = 'columnResize';
export var COLUMN_SIZE_KEY = 'columnResize';
export var RESIZED_COLUMN_KEY = 'resizedColumn';
export var LAST_RESIZED_COLUMN_KEY = 'lastResizedColumn';
export function columnResize() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _a, _b, _c;
  var minSize = (_a = opts.minSize) !== null && _a !== void 0 ? _a : 60;
  var fallbackSize = (_b = opts.fallbackSize) !== null && _b !== void 0 ? _b : 150;
  var maxSize = (_c = opts.maxSize) !== null && _c !== void 0 ? _c : 1000;
  return function columnResizeFeature(pipeline) {
    var _a, _b;
    var columnSize = (_b = (_a = opts.columnSize) !== null && _a !== void 0 ? _a : pipeline.getStateAtKey(stateKey)) !== null && _b !== void 0 ? _b : {};
    var leafColumns = collectNodes(pipeline.getColumns(), 'leaf-only');
    leafColumns.forEach(function (_ref) {
      var code = _ref.code,
        width = _ref.width;
      if (columnSize[code] === undefined) {
        if (typeof width === 'number') {
          columnSize[code] = width;
        } else {
          columnSize[code] = fallbackSize;
        }
      }
    });
    // 实时存储一份最新的columnSize，与autoFill共用一份数据
    // 存在state里可能存到取不到最新的
    pipeline.setFeatureOptions(COLUMN_SIZE_KEY, columnSize);
    var onChangeSize = function onChangeSize(nextColumnSize) {
      window.requestAnimationFrame(function () {
        var _a;
        pipeline.setStateAtKey(stateKey, nextColumnSize);
        (_a = opts === null || opts === void 0 ? void 0 : opts.onChangeSize) === null || _a === void 0 ? void 0 : _a.call(opts, nextColumnSize);
      });
    };
    var handleDoubleClick = function handleDoubleClick(e, col) {
      var _a;
      (_a = opts.doubleClickCallback) === null || _a === void 0 ? void 0 : _a.call(opts, e, col);
    };
    // 通用的拖拽处理逻辑
    var handleResize = function handleResize(startEvent, col, eventType) {
      window.addEventListener('selectstart', disableSelect);
      var changedColumnSize = {};
      var startCoordinates = getEventCoordinates(startEvent);
      var startX = startCoordinates.clientX;
      var children = col.children,
        code = col.code,
        _col$features = col.features,
        features = _col$features === void 0 ? {} : _col$features;
      var minWidth = features.minWidth,
        maxWidth = features.maxWidth;
      var realMinSize = typeof minWidth === 'number' ? minWidth : minSize;
      var realMaxSize = typeof maxWidth === 'number' ? maxWidth : maxSize;
      var columnSize = pipeline.getFeatureOptions(COLUMN_SIZE_KEY);
      var recordColumnSize = columnSize;
      // 根据事件类型选择不同的事件监听器
      var moveEventName = eventType === 'mouse' ? 'mousemove' : 'touchmove';
      var endEventName = eventType === 'mouse' ? 'mouseup' : 'touchend';
      var moveEventOptions = eventType === 'touch' ? {
        passive: false
      } : undefined;
      var endEventOptions = eventType === 'touch' ? {
        passive: false
      } : undefined;
      var nextSize$ = fromEvent(window, moveEventName, moveEventOptions).pipe(op.takeUntil(fromEvent(window, endEventName, endEventOptions)), op.map(function (e) {
        // 触摸事件需要阻止默认行为，防止页面滚动
        if (eventType === 'touch' && e.cancelable) {
          e.preventDefault();
        }
        var coordinates = getEventCoordinates(e);
        var movingX = coordinates.clientX;
        var nextColumnSize = _extends({}, columnSize);
        var deltaSum = pipeline.ctx.direction === 'rtl' ? startX - movingX : movingX - startX;
        var deltaRemaining = deltaSum;
        if ((children === null || children === void 0 ? void 0 : children.length) > 0) {
          var leafChildColumns = collectNodes(children, 'leaf-only');
          var childrenWidthSum = leafChildColumns.reduce(function (sum, _ref2) {
            var code = _ref2.code;
            return sum + columnSize[code];
          }, 0);
          leafChildColumns.forEach(function (_ref3, index) {
            var code = _ref3.code;
            var startSize = columnSize[code];
            var currentDeltaWidth = Math.round(deltaSum * startSize / childrenWidthSum);
            if (index < leafChildColumns.length - 1) {
              nextColumnSize[code] = clamp(realMinSize, startSize + currentDeltaWidth, realMaxSize);
              changedColumnSize[code] = nextColumnSize[code];
              deltaRemaining -= currentDeltaWidth;
            } else {
              nextColumnSize[code] = clamp(realMinSize, startSize + deltaRemaining, realMaxSize);
              changedColumnSize[code] = nextColumnSize[code];
            }
          });
        } else {
          var startSize = columnSize[code];
          nextColumnSize[code] = clamp(realMinSize, startSize + deltaSum, realMaxSize);
          changedColumnSize[code] = nextColumnSize[code];
        }
        recordColumnSize = nextColumnSize;
        return nextColumnSize;
      }));
      nextSize$.subscribe({
        next: function next(nextColumnSize) {
          onChangeSize(nextColumnSize);
          // 由于COLUMN_RESIZE_KEY记录的是全量的列宽，此处记录被改变过的列宽
          var resizedColumnSet = pipeline.getFeatureOptions(RESIZED_COLUMN_KEY) || new _Set();
          _Object$keys(changedColumnSize).forEach(function (code) {
            resizedColumnSet.add(code, changedColumnSize[code]);
          });
          pipeline.setFeatureOptions(RESIZED_COLUMN_KEY, resizedColumnSet);
          pipeline.setFeatureOptions(LAST_RESIZED_COLUMN_KEY, code);
        },
        complete: function complete() {
          var _context;
          var changedColumnSizes = _mapInstanceProperty(_context = _Object$keys(changedColumnSize)).call(_context, function (code) {
            return {
              code: code,
              width: changedColumnSize[code]
            };
          });
          window.requestAnimationFrame(function () {
            var _a;
            (_a = opts === null || opts === void 0 ? void 0 : opts.afterChangeSize) === null || _a === void 0 ? void 0 : _a.call(opts, recordColumnSize, changedColumnSizes);
          });
          window.removeEventListener('selectstart', disableSelect);
        }
      });
    };
    var handleMouseDown = function handleMouseDown(e, col) {
      e.stopPropagation();
      handleResize(e.nativeEvent, col, 'mouse');
    };
    // 触摸事件处理函数
    var handleTouchStart = function handleTouchStart(e, col) {
      // 阻止触摸事件的默认行为
      if (e.cancelable) {
        e.preventDefault();
      }
      e.stopPropagation();
      handleResize(e.nativeEvent, col, 'touch');
    };
    var isGroup = isGroupColumn(pipeline.getColumns());
    return pipeline.mapColumns(makeRecursiveMapper(function (col) {
      var _a;
      var prevTitle = internals.safeRenderHeader(col);
      var code = col.code,
        features = col.features,
        width = col.width;
      return _extends(_extends({}, col), {
        width: (_a = columnSize[code]) !== null && _a !== void 0 ? _a : width,
        title: /*#__PURE__*/React.createElement(React.Fragment, null, prevTitle, (features === null || features === void 0 ? void 0 : features.resizeable) !== false && (isGroup ? /*#__PURE__*/React.createElement(TableHeaderGroupCellResize, {
          direction: pipeline.ctx.direction,
          className: Classes.tableHeaderCellResize,
          onDoubleClick: function onDoubleClick(e) {
            return handleDoubleClick(e, col);
          },
          onMouseDown: function onMouseDown(e) {
            return handleMouseDown(e, col);
          },
          onTouchStart: function onTouchStart(e) {
            return handleTouchStart(e, col);
          }
        }) : /*#__PURE__*/React.createElement(TableHeaderCellResize, {
          direction: pipeline.ctx.direction,
          className: Classes.tableHeaderCellResize,
          onDoubleClick: function onDoubleClick(e) {
            return handleDoubleClick(e, col);
          },
          onMouseDown: function onMouseDown(e) {
            return handleMouseDown(e, col);
          },
          onTouchStart: function onTouchStart(e) {
            return handleTouchStart(e, col);
          }
        }))),
        headerCellProps: mergeCellProps(col.headerCellProps, {
          className: 'resizeable'
        })
      });
    }));
  };
}